<template>
  <div :class="$style.root">
    <core-text-component
      v-if="caption"
      :string="caption"
      :key="caption"
    />
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  caption: {
    type: String,
    required: false
  }
})
</script>

<style module>
.root {
  composes: font-size-small caption from global;
  margin-top: var(--unit--vertical);
}
</style>
